@if (_weather()?.icon) {
  <span title="{{ weather.icon }}"> {{ +weather.temp }}° <i class="qi qi-{{ fontIcon }}"></i> </span>
}
